import CheckoutProvider from 'context/checkout/Checkout'
import EventProvider from 'context/events/Event'
import CollapseProvider from 'context/general/Collapse'
import OnSelectMenuProvider from 'context/general/OnSelectMenu'
import DashHeader from 'modules/dashboard/_common/DashHeader'
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions'
import EstablishmentFullPage from 'modules/establishment/page/EstablishmentFullPage'
import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'

export default function EstablishmentPage() {
    return (
        <EventProvider>
            <CheckoutProvider>
                <CollapseProvider>
                    <OnSelectMenuProvider>
                        <StyledHeader>
                            <DashHeader userView={true} />
                            <DashHeaderActions />
                        </StyledHeader>
                        
                        <EstablishmentFullPage />

                    </OnSelectMenuProvider>
                </CollapseProvider>
            </CheckoutProvider>
        </EventProvider>
    )
}

const StyledHeader = styled.span`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;